import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { visitService } from '../visitService';

export function useVisits(page = 1, limit = 20, filters?: { search?: string; visitType?: string; status?: string; dateFrom?: string; dateTo?: string }) {
  return useQuery({
    queryKey: ['visits', page, limit, filters],
    queryFn: () => visitService.getVisits(page, limit, filters),
    placeholderData: (previous) => previous,
    staleTime: 30000,
  });
}

export function useVisit(id: string) {
  return useQuery({
    queryKey: ['visits', id],
    queryFn: () => visitService.getVisit(id),
    enabled: !!id,
  });
}

export function useCreateVisit() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: visitService.createVisit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['visits'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useUpdateVisit() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) => visitService.updateVisit(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['visits', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['visits'] });
    },
  });
}

export function useCloseVisit() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => visitService.closeVisit(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['visits'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useActiveVisitsByPatient(patientId: string) {
  return useQuery({
    queryKey: ['visits', 'active', patientId],
    queryFn: () => visitService.getActiveVisitsByPatient(patientId),
    enabled: !!patientId,
    staleTime: 10000,
  });
}
